/* eslint-disable no-nested-ternary */
/* eslint-disable react/forbid-prop-types */
/**
 * SEO component that queries for data with
 *  Gatsby's useStaticQuery React hook
 *
 * See: https://www.gatsbyjs.com/docs/use-static-query/
 */

import { isEmpty } from 'lodash';
import * as React from 'react';
import { Helmet } from 'react-helmet';

function Seo({ page, lang, dir, type }) {
  let socialMediaImage =
    page.socialMediaImage && page.socialMediaImage.url ? page.socialMediaImage.url : '';
  socialMediaImage =
    !socialMediaImage && !isEmpty(page.featuredImage) ? page.featuredImage.url : '';
  // socialMediaImage = !socialMediaImage && !isEmpty(page.darkLogo) ? page.darkLogo.url : '';

  let title = `${dir === 'rtl' ? 'مركز دبي التجاري العالمي' : 'Dubai World Trade Centre'} - ${
    page.metadataTitle || page.title || page.name
  }`;
  if (page.contentTypeAlias === 'insight') {
    title = page.metadataTitle || page.title || page.name;
  }
  const description = page.metadataDescription || page.description;
  const keywords = page.metadataKeywords;
  const metaDescription = description; // || site.siteMetadata.description
  const defaultTitle = ''; // site.siteMetadata?.title
  let { createDate } = page;
  let { updateDate } = page;
  if (page.articleDate) {
    createDate = page.articleDate;
    updateDate = page.articleDate;
  }
  if (page.startDate) {
    createDate = page.startDate;
    updateDate = page.startDate;
  }

  const structure =
    type === 'event'
      ? JSON.stringify({
          '@context': 'https://schema.org',
          '@type': 'Event',
          name: page.title,
          startDate: page.startDate,
          endDate: page.endDate,
          eventAttendanceMode:
            page.eventAudiences || 'https://schema.org/OfflineEventAttendanceMode',
          location: {
            '@type': 'Place',
            name: page.eventVenues.join(', '),
          },
          image: [
            page.eventLogo?.url.replace('dev-dwtc-new', 'dwtc-new').replace('stage-dwtc-new', 'dwtc-new'),
            page.featuredImage?.url.replace('dev-dwtc-new', 'dwtc-new').replace('stage-dwtc-new', 'dwtc-new'),
          ],
          description: page.description,
          organizer: {
            '@type': 'Organization',
            name: page.eventOrganiser,
            url: page.eventOrganiser === 'Dubai World Trade Centre' ? 'https://www.dwtc.com' : '',
          },
        })
      : type === 'insight'
      ? JSON.stringify({
          '@context': 'https://schema.org',
          '@type': 'Article',
          headline: page.title,
          image: [
            page.featuredImage?.url.replace('dev-dwtc-new', 'dwtc-new').replace('stage-dwtc-new', 'dwtc-new'),
            page.heroImage?.url.replace('dev-dwtc-new', 'dwtc-new').replace('stage-dwtc-new', 'dwtc-new'),
          ],
          datePublished: page.articleDate,
          dateModified: page.articleDate,
          author: [
            {
              '@type': 'Organization',
              name: 'Dubai World Trade Centre',
              url: 'https://www.dwtc.com',
            },
          ],
        })
      : '';

  return (
    <Helmet
      htmlAttributes={{
        lang,
        dir,
      }}
      title={title}
      titleTemplate={defaultTitle ? `%s | ${defaultTitle}` : null}
      meta={[
        {
          name: `description`,
          content: metaDescription,
        },
        {
          name: `keywords`,
          content: keywords,
        },
        {
          property: `og:title`,
          content: title,
        },
        {
          property: `og:description`,
          content: metaDescription,
        },
        {
          property: `og:type`,
          content: `DWTC Page`,
        },
        {
          property: `og:url`,
          content: page.url,
        },
        {
          property: `article:tag`,
          content: `DWTC Page`,
        },
        {
          property: `og:site_name`,
          content: `dwtc.com`,
        },
        {
          property: `article:published_time`,
          content: createDate,
        },
        {
          property: `article:modified_time`,
          content: updateDate,
        },
        {
          name: `twitter:card`,
          content: `summary`,
        },
        {
          name: `twitter:title`,
          content: title,
        },
        {
          name: `og:image`,
          content: socialMediaImage,
        },
        {
          name: `twitter:image`,
          content: socialMediaImage,
        },
        {
          name: `twitter:image:src`,
          content: socialMediaImage,
        },
        {
          name: `twitter:description`,
          content: metaDescription,
        },
        {
          name: `twitter:siten`,
          content: '@DWTCCARE',
        },
      ].concat([])}
    >
      structure && <script type="application/ld+json">{structure}</script>
    </Helmet>
  );
}

export default Seo;
